module.exports = __webpack_public_path__ + "static/primary-illustration-0967f3e8615819cc9bf1fc57750bb426.png";